/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Jadwal_GInputs */

const en_tut_jadwal_g = /** @type {(inputs: Tut_Jadwal_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So that scheduled meetings are not missed, KerjaBareng shows the nearest ones where you already look, then reminds you shortly before they start.`)
};

const id_tut_jadwal_g = /** @type {(inputs: Tut_Jadwal_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supaya rapat yang sudah dijadwalkan tidak terlewat, KerjaBareng menampilkan jadwal terdekat di tempat yang memang Anda buka, lalu mengingatkan menjelang mulai.`)
};

/**
* | output |
* | --- |
* | "So that scheduled meetings are not missed, KerjaBareng shows the nearest ones where you already look, then reminds you shortly before they start." |
*
* @param {Tut_Jadwal_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_jadwal_g = /** @type {((inputs?: Tut_Jadwal_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Jadwal_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_jadwal_g(inputs)
	return en_tut_jadwal_g(inputs)
});